import type React from "react"

import { Field, FieldError, FieldLabel, Textarea } from "@atlant/ui"

interface FormTextareaProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  name?: string
  label?: string
  placeholder?: string
  disabled?: boolean
  className?: string
  rows?: number
  error?: string
  required?: boolean
}

export const FormTextarea = ({
  value,
  onChange,
  onBlur,
  name,
  label,
  placeholder,
  disabled,
  className,
  rows = 1,
  error,
  required,
}: FormTextareaProps) => {
  const id = name ?? label?.toLowerCase().replace(/\s+/g, "-")

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value)
  }

  return (
    <Field className={className} data-invalid={error ? true : undefined}>
      {label && (
        <FieldLabel
          htmlFor={id}
          className="text-muted-foreground gap-1 text-sm font-medium"
        >
          {label}
          {required && <span className="text-xs text-red-500">*</span>}
        </FieldLabel>
      )}
      <Textarea
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        aria-invalid={error ? true : undefined}
        className="shadow-custom! placeholder:text-placeholder min-h-10 bg-white placeholder:text-sm dark:shadow-none!"
      />
      {error && <FieldError>{error}</FieldError>}
    </Field>
  )
}
